import PurchaseMethod from '@/types/purchaseRequest/purchaseMethod'
import { BaseService } from './../../base'
export class PurchaseMethodService extends BaseService<PurchaseMethod>() {
    static get entity (): string {
        return 'purchase_method'
    }
    static get responseName (): string {
        return 'purchase_method'
    }
}